import * as React from "react";
import { getExperienceProgress } from "@/utils/experience";
import LevelProgress from "@/components/atomics/level-progress";
import { ViewState } from "@/types/owner-edit";

interface OwnerAvatarType {
  className?: string;
  image: string;
  onImageChange?: (file: File) => void;
  experience: number;
  viewState: ViewState;
}

export default function OwnerAvatar({
  className,
  image,
  onImageChange,
  experience,
  viewState,
}: OwnerAvatarType) {
  const {
    level,
    currentExp,
    expToCurrentLevel,
    expToNextLevel,
    remainingExp,
    requiredExp,
  } = getExperienceProgress(experience);

  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && onImageChange) {
      onImageChange(file);
    }
  };

  return (
    <div
      className={`${className} relative aspect-square cursor-pointer`}
      onClick={handleClick}
    >
      <img className="rounded-full" src={image} alt="avatar" />
      <div className="absolute w-[153px] aspect-square z-[2] top-[calc(50%-2px)] left-[50%] translate-x-[-50%] translate-y-[-50%]">
        <img src="/assets/circle-bg.png" alt="avatar" />
      </div>
      <div className="absolute w-[41px] aspect-square z-[3] right-[-6px] top-[-9px]">
        <LevelProgress
          level={level}
          currentExp={currentExp}
          expToCurrentLevel={expToCurrentLevel}
          expToNextLevel={expToNextLevel}
          remainingExp={remainingExp}
          requiredExp={requiredExp}
          viewState={viewState}
        />
      </div>
    </div>
  );
}
